/**
 * Overrides {@link sharedModule.redirectAnonymousToGate} for login.
 */
import { IRedirectAnonymousToGate } from '@shared/app/scripts/services/redirect-anonymous-to-gate';

export const RedirectAnonymousToGateProvider: {
  provide: string;
  useFactory: () => IRedirectAnonymousToGate;
} = {
  provide: 'redirectAnonymousToGate',
  // Note! useValue fails for falsy values
  useFactory: () => false,
};
